module.exports = __webpack_public_path__ + "static/media/b.6af5ec46.svg";